import { Fragment } from 'react';
import { Modal } from 'react-bootstrap';

const EliminarFacturaModal = ({ show, factura, onCancel, onConfirm }) => {
    return (
        <Fragment>
            <Modal show={show} onHide={onCancel} centered backdrop="static">
                <Modal.Header closeButton>
                    <Modal.Title>Eliminar factura</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <div className="alert alert-warning mb-0">
                        ¿Seguro que deseas eliminar la factura <b>{factura?.numero || ''}</b>?
                        <br />
                        Esta acción no se puede deshacer.
                    </div>
                </Modal.Body>

                <Modal.Footer>
                    <button type="button" className="btn btn-secondary" onClick={onCancel}>
                        Cancelar
                    </button>

                    <button type="button" className="btn btn-danger" onClick={onConfirm}>
                        Eliminar
                    </button>
                </Modal.Footer>
            </Modal>
        </Fragment>
    );
};

export default EliminarFacturaModal;
